import { render } from "./changePwd.vue?vue&type=template&id=31051244&scoped=true"
import script from "./changePwd.vue?vue&type=script&lang=js"
export * from "./changePwd.vue?vue&type=script&lang=js"

import "./changePwd.vue?vue&type=style&index=0&id=31051244&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-31051244"

export default script